import { Landmark, Users, Home, NotebookPen, Handshake, FolderKanban } from "lucide-react";
import { useContext, useState } from "react";
import { GlobalContext } from "../context/Context";

const Organization = (
  <svg
    width="32"
    height="30"
    viewBox="0 0 32 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8999 18.8181L12.9092 18.8181"
      stroke="#222222"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6333 18.8181L16.6426 18.8181"
      stroke="#222222"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 21.6818C4.5 22.1881 4.69667 22.6737 5.04673 23.0317C5.3968 23.3897 5.8716 23.5908 6.36667 23.5908L19.4333 23.5908C19.9284 23.5908 20.4032 23.3897 20.7533 23.0317C21.1033 22.6737 21.3 22.1881 21.3 21.6818L21.3 11.659C21.3001 11.5734 21.2777 11.4893 21.235 11.4156C21.1924 11.3419 21.1312 11.2813 21.0578 11.2401C20.9844 11.1989 20.9016 11.1787 20.8179 11.1815C20.7342 11.1843 20.6528 11.2101 20.5823 11.2562L16.4177 13.9709C16.3472 14.017 16.2658 14.0428 16.1821 14.0456C16.0984 14.0485 16.0156 14.0282 15.9422 13.987C15.8688 13.9458 15.8076 13.8852 15.765 13.8115C15.7223 13.7378 15.6999 13.6537 15.7 13.5681L15.7 11.659C15.7001 11.5734 15.6777 11.4893 15.635 11.4156C15.5924 11.3419 15.5312 11.2813 15.4578 11.2401C15.3844 11.1989 15.3016 11.1787 15.2179 11.1815C15.1342 11.1843 15.0528 11.2101 14.9823 11.2562L10.8187 13.9709C10.7481 14.0172 10.6666 14.0433 10.5828 14.0462C10.499 14.0492 10.4159 14.029 10.3424 13.9878C10.2688 13.9465 10.2075 13.8858 10.1649 13.812C10.1222 13.7381 10.0998 13.6539 10.1 13.5681L10.1 8.31812C10.1 7.81179 9.90333 7.32621 9.55327 6.96818C9.2032 6.61016 8.7284 6.40903 8.23333 6.40903L6.36667 6.40903C5.8716 6.40903 5.3968 6.61016 5.04673 6.96818C4.69667 7.32621 4.5 7.81179 4.5 8.31812L4.5 21.6818Z"
      stroke="#222222"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter0_d_615_24404)" data-figma-bg-blur-radius="1.9">
      <path
        d="M12.5 16.0606C12.5 16.5026 12.6717 16.9266 12.9773 17.2391C13.2829 17.5517 13.6974 17.7273 14.1296 17.7273L25.537 17.7273C25.9692 17.7273 26.3837 17.5517 26.6894 17.2391C26.995 16.9266 27.1667 16.5026 27.1667 16.0606L27.1667 7.31061C27.1667 7.23586 27.1472 7.16246 27.11 7.09812C27.0728 7.03377 27.0193 6.98085 26.9553 6.94489C26.8912 6.90893 26.8188 6.89126 26.7458 6.89373C26.6727 6.8962 26.6017 6.91873 26.5401 6.95894L22.9044 9.32894C22.8428 9.36915 22.7717 9.39168 22.6987 9.39415C22.6256 9.39662 22.5533 9.37895 22.4892 9.34299C22.4251 9.30703 22.3717 9.25411 22.3345 9.18976C22.2973 9.12542 22.2777 9.05202 22.2778 8.97727L22.2778 7.31061C22.2779 7.23586 22.2583 7.16246 22.2211 7.09812C22.1839 7.03377 22.1304 6.98085 22.0664 6.94489C22.0023 6.90893 21.9299 6.89126 21.8569 6.89373C21.7838 6.8962 21.7128 6.91873 21.6512 6.95894L18.0163 9.32894C17.9547 9.36937 17.8835 9.39208 17.8104 9.39466C17.7372 9.39725 17.6647 9.37962 17.6005 9.34364C17.5363 9.30765 17.4828 9.25463 17.4455 9.19016C17.4083 9.12569 17.3887 9.05215 17.3889 8.97727L17.3889 4.39394C17.3889 3.95191 17.2172 3.52799 16.9116 3.21543C16.606 2.90287 16.1915 2.72727 15.7593 2.72727L14.1296 2.72727C13.6974 2.72727 13.2829 2.90287 12.9773 3.21543C12.6717 3.52799 12.5 3.95191 12.5 4.39394L12.5 16.0606Z"
        fill="#FF4086"
        fillOpacity="0.3"
        shapeRendering="crispEdges"
      />
    </g>
    <path
      d="M9.1665 18.8181L9.17584 18.8181"
      stroke="#222222"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_615_24404"
        x="10.6"
        y="0.827274"
        width="20.6665"
        height="22"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="1.05" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_615_24404"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_615_24404"
          result="shape"
        />
      </filter>
      <clipPath
        id="bgblur_0_615_24404_clip_path"
        transform="translate(-10.6 -0.827274)"
      >
        <path d="M12.5 16.0606C12.5 16.5026 12.6717 16.9266 12.9773 17.2391C13.2829 17.5517 13.6974 17.7273 14.1296 17.7273L25.537 17.7273C25.9692 17.7273 26.3837 17.5517 26.6894 17.2391C26.995 16.9266 27.1667 16.5026 27.1667 16.0606L27.1667 7.31061C27.1667 7.23586 27.1472 7.16246 27.11 7.09812C27.0728 7.03377 27.0193 6.98085 26.9553 6.94489C26.8912 6.90893 26.8188 6.89126 26.7458 6.89373C26.6727 6.8962 26.6017 6.91873 26.5401 6.95894L22.9044 9.32894C22.8428 9.36915 22.7717 9.39168 22.6987 9.39415C22.6256 9.39662 22.5533 9.37895 22.4892 9.34299C22.4251 9.30703 22.3717 9.25411 22.3345 9.18976C22.2973 9.12542 22.2777 9.05202 22.2778 8.97727L22.2778 7.31061C22.2779 7.23586 22.2583 7.16246 22.2211 7.09812C22.1839 7.03377 22.1304 6.98085 22.0664 6.94489C22.0023 6.90893 21.9299 6.89126 21.8569 6.89373C21.7838 6.8962 21.7128 6.91873 21.6512 6.95894L18.0163 9.32894C17.9547 9.36937 17.8835 9.39208 17.8104 9.39466C17.7372 9.39725 17.6647 9.37962 17.6005 9.34364C17.5363 9.30765 17.4828 9.25463 17.4455 9.19016C17.4083 9.12569 17.3887 9.05215 17.3889 8.97727L17.3889 4.39394C17.3889 3.95191 17.2172 3.52799 16.9116 3.21543C16.606 2.90287 16.1915 2.72727 15.7593 2.72727L14.1296 2.72727C13.6974 2.72727 13.2829 2.90287 12.9773 3.21543C12.6717 3.52799 12.5 3.95191 12.5 4.39394L12.5 16.0606Z" />
      </clipPath>
    </defs>
  </svg>
);

const DashboardOverview = (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
    <path d="M23.2353 21.4156C24.4623 19.7415 24.3128 17.4114 22.7679 15.9097C21.1117 14.2998 18.1859 14.2988 16.5316 15.9097C14.8073 17.5843 14.8083 20.2973 16.5316 21.9715C18.0766 23.4747 20.4742 23.618 22.196 22.4259L24 24.5L25.0393 23.4898L23.2353 21.4156Z" fill="#EB6F61" />
    <path d="M5.80895 16.7793C5.21555 16.7341 4.72408 17.2118 4.77112 17.7886C4.80787 18.2425 5.18615 18.6102 5.65313 18.6459C6.24701 18.6917 6.73897 18.213 6.69144 17.6357C6.6542 17.1818 6.27592 16.8146 5.80895 16.7789V16.7793Z" fill="black" />
    <path d="M5.80895 10.7325C5.21555 10.6872 4.72408 11.1649 4.77112 11.7417C4.80787 12.1956 5.18615 12.5633 5.65313 12.5991C6.24701 12.6448 6.73897 12.1661 6.69144 11.5888C6.6542 11.1349 6.27592 10.7677 5.80895 10.732V10.7325Z" fill="black" />
    <path d="M5.80895 5.01835C5.21555 4.9731 4.72408 5.45083 4.77112 6.02762C4.80787 6.48153 5.18615 6.84923 5.65313 6.88495C6.24701 6.93068 6.73897 6.452 6.69144 5.87473C6.6542 5.42082 6.27592 5.0536 5.80895 5.01788V5.01835Z" fill="black" />
    <path d="M2.54702 23.6176C1.14268 23.6176 0 22.5069 0 21.1418V2.47578C0 1.11072 1.14268 0 2.54702 0H21.7496C23.154 0 24.2967 1.11072 24.2967 2.47578V12.2846C24.2967 12.5994 24.033 12.8557 23.7092 12.8557C23.3853 12.8557 23.1216 12.5994 23.1216 12.2846V2.47578C23.1216 1.74038 22.5062 1.14263 21.7501 1.14263H2.54702C1.79046 1.14263 1.17502 1.74086 1.17502 2.47626V21.1418C1.17502 21.8772 1.79046 22.4754 2.54702 22.4754H12.8831C13.207 22.4754 13.4706 22.7317 13.4706 23.0465C13.4706 23.3613 13.207 23.6176 12.8831 23.6176H2.54702ZM10.3851 18.2845C10.0612 18.2845 9.79756 18.0282 9.79756 17.7134C9.79756 17.3986 10.0612 17.1423 10.3851 17.1423H11.7566C12.0805 17.1423 12.3441 17.3986 12.3441 17.7134C12.3441 18.0282 12.0805 18.2845 11.7566 18.2845H10.3851ZM10.3851 12.237C10.0612 12.237 9.79756 11.9807 9.79756 11.6659C9.79756 11.3511 10.0612 11.0948 10.3851 11.0948H18.3206C18.6445 11.0948 18.9081 11.3511 18.9081 11.6659C18.9081 11.9807 18.6445 12.237 18.3206 12.237H10.3851ZM10.3851 6.52334C10.0612 6.52334 9.79756 6.26709 9.79756 5.95226C9.79756 5.63743 10.0612 5.38118 10.3851 5.38118H18.3206C18.6445 5.38118 18.9081 5.63743 18.9081 5.95226C18.9081 6.26709 18.6445 6.52334 18.3206 6.52334H10.3851Z" fill="black" />
  </svg>
)


const useNav = () => {
  let { state } = useContext(GlobalContext);

  const [navList, setNavList] = useState({

    topRefundNav: [
      {
        name: "Organization",
        icon: Organization,
        url: "/refunds/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),



    refundOrgBottomNav: [
      { name: "Overview", url: "/refunds/organization/overview", activeKey: "overview" },

      { name: "List", url: "/refunds/organization/refund", activeKey: "refund" },
      { name: "By Department", url: "/refunds/organization/report-by-department", activeKey: "report-by-department" },
      { name: "By Sales Agent", url: "/refunds/organization/report-by-sales-agent", activeKey: "report-by-sales-agent" },
      { name: "Monthly Trends", url: "/refunds/organization/report-monthly-trend", activeKey: "report-monthly-trend" },

      { name: "By Product", url: "/refunds/organization/report-by-product", activeKey: "report-by-product" },
      { name: "By Website", url: "/refunds/organization/report-by-brand", activeKey: "report-by-brand" },
      { name: "By Source", url: "/refunds/organization/report-by-source", activeKey: "report-by-source" },
      { name: "By Merchant", url: "/refunds/organization/report-by-merchant", activeKey: "report-by-merchant" },
      { name: "By Account Manager", url: "/refunds/organization/report-by-account-manager", activeKey: "report-by-account-manager" },
      { name: "By Team Lead", url: "/refunds/organization/report-by-team-lead", activeKey: "report-by-team-lead" },
      { name: "By QA Status", url: "/refunds/organization/report-by-qa-status", activeKey: "report-by-qa-status" },



    ].filter(Boolean),

    topBillingNav: [
      {
        name: "Calls",
        icon: Organization,
        url: "/billing/calls/all",
        activeKey: "calls",
      },
      {
        name: "Meetings",
        icon: Organization,
        url: "/billing/meetings/all",
        activeKey: "meetings",
      },
    ].filter(Boolean),

    topBillingReportsNav: [
      {
        name: "Reports",
        icon: Organization,
        url: "/billing/reports/keywords",
        activeKey: "reports",
      },

    ].filter(Boolean),

    billingCallBottomNav: [
      { name: "All Calls", url: "/billing/calls/all", activeKey: "all" },
      { name: "My Calls", url: "/billing/calls/my", activeKey: "my" },
      { name: "Picked Calls", url: "/billing/calls/picked", activeKey: "picked" },
      { name: "QA Escalation", url: "/billing/calls/flagged-qa", activeKey: "flagged-qa" },
      { name: "Lead Flag to Manager", url: "/billing/calls/flagged-manager", activeKey: "flagged-manager" },
    ].filter(Boolean),

    billingCustomerBottomNav: [
      { name: "Customers", url: "/billing/customers/customer", activeKey: "customer" },
    ].filter(Boolean),


    billingReportsBottomNav: [
      { name: "Keywords Stats", url: "/billing/reports/keywords", activeKey: "keywords" },
    ].filter(Boolean),

    billingMeetingBottomNav: [
      { name: "All Meetings", url: "/billing/meetings/all", activeKey: "all" },
      { name: "My Meetings", url: "/billing/meetings/my", activeKey: "my" },
      { name: "Picked Meetings", url: "/billing/meetings/picked", activeKey: "picked" },
      { name: "QA Escalation", url: "/billing/meetings/flagged-qa", activeKey: "flagged-qa" },
      { name: "Lead Flag to Manager", url: "/billing/meetings/flagged-manager", activeKey: "flagged-manager" },
    ].filter(Boolean),


    topConfigNav: [
      {
        name: "Config",
        icon: Organization,
        url: "/config/departments",
        activeKey: "config",
      },
      {
        name: "Customers",
        icon: Organization,
        url: "/billing/customers/customer",
        activeKey: "customers",
      }
    ].filter(Boolean),

    configBottomNav: [
      { name: "Departments", url: "/config/departments", activeKey: "departments" },
      { name: "Work Status", url: "/config/work_status", activeKey: "work_status" },
      { name: "Charge Back or Refund", url: "/config/cb_or_refund", activeKey: "cb_or_refund" },
      { name: "Source", url: "/config/source", activeKey: "source" },
      { name: "Qa Status", url: "/config/qa_status", activeKey: "qa_status" },
      { name: "Responsible", url: "/config/responsible", activeKey: "responsible" },
      { name: "Retention Outcome", url: "/config/retention_outcome", activeKey: "retention_outcome" },
      { name: "Charge Back Outcome", url: "/config/cb_outcome", activeKey: "cb_outcome" },
      { name: "Year", url: "/config/year", activeKey: "year" },
      { name: "Quater", url: "/config/quarter", activeKey: "quarter" },

    ].filter(Boolean),



  });

  const checkCondi = state?.user?.dashboardRole === "single";
  const allowKeys = ["FuelTopHeader", "FuelOrgBottom"];

  const finalNavList = checkCondi
    ? Object.fromEntries(
      Object.entries(navList).map(([key, navArray]) => [
        key,
        navArray.map((item) => ({
          ...item,
          url: allowKeys.includes(key) ? item.url : "",
        })),
      ])
    )
    : navList;

  return finalNavList;
};

export default useNav;



